// src/ErrorBoundary.js
import React from "react";
import { logError } from "./logger";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, referenceCode: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const referenceCode = logError(error, errorInfo);
    this.setState({ referenceCode });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          {this.state.referenceCode && (
            <p>
              Reference Code: <strong>{this.state.referenceCode}</strong>
            </p>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
